<template>
  <div class="social-int-page" data-track="Social Integration">
    <div class="">
      <div class="is-12-mobile is-12-desktop is-12-widescreen">
        <div class="is-clearfix">
          <div class="is-pulled-left title is-marginless is-paddingless main-head">Social Integration
            <span v-if="is_loading"
                  class="button is-marginless is-white has-text-right preloader padding-left-0"
                  :class="{'is-loading': is_loading}">
            </span>
          </div>
          <a class="about-feature is-pulled-right" target="_blank" data-track="Show Additional QR Codes view"
          href="https://intercom.help/hellopeter/en/articles/4227612-facebook-review-tab">
            <img src="/static/img/dummy-help.png"/>
            <span class="abt_section">About this feature</span>
          </a>
        </div>
        <div class="head-border"><hr></div>
        <div v-if="!is_loading">
          <div class="social-desc">
            <div class=" padding-left-0">
              <p class="head-content">
                Social proof enables you to build trust and credibility amongst your customers and potential customers. Connect your Hellopeter account to
                your social media platforms to get greater visibility for your reviews, and reach the audience you care about.
              </p>
            </div>
          </div>
          <div class="fb-tab-landing-page" v-if="!is_loading">
            <div class="fb-heading-section">
              <img :src="fbHeadImgUrl" />
              <span class="fb-head-text">Add Facebook tab</span>
              <img v-if="isFreeSubscription" class="lock-icon" src="/static/img/free-lock-icon.svg" width="15" height="15" alt="Free Subscription" />
            </div>
            <div class="content-section" v-if="!isFreeSubscription">
              <div class="content-child-section">
                <div class="columns social-img">
                  <div><img :src="hpImgUrl" /></div>
                  <span class="plus-icon">+</span>
                  <div><img class="fb-icon" :src="facebookImgUrl" /></div>
                </div>
                <div class="note-text">
                  <p>
                    Display your reviews in your Facebook feed by installing the Hellopeter tab.
                  </p>
                </div>
                <div class="information-section">
                  <div class="note-text information-desc"  v-if="!facebookPageId && !pageAccessToken" >
                    <img src="/static/img/fb-note.png" alt="add tab now" />
                  </div>
                  <div class="note-text information-desc tab-already-added-note"  v-if="facebookPageId">
                    <div>
                      <i class="fa fa-check" aria-hidden="true"></i>
                    </div>
                    <div>
                      <span>The Hellopeter review tab has successfully been installed on your Facebook page.</span>
                    </div>
                  </div>
                </div>
                <div v-if="isAddTabButtonVisible" class="btn-section" :class="[{'is-add-tab-btn-disabled': facebookPageId && !pageAccessToken}]">
                  <a href="#" @click.prevent="addFacebookTab" class="button is-button-blue-outline" data-track="Add Facebook Page Tab Button Clicked">
                    ADD TAB NOW
                  </a>
                </div>
                <div v-else class="btn-section">
                  <a href="#" @click.prevent="removeFacebookTab" class="button is-button-blue-outline" data-track="Add Facebook Page Tab Button Clicked">
                    REMOVE TAB
                  </a>
                </div>
              </div>
            </div>
            <div v-else>
              <p class="fb-tab-content">
                <router-link to="/billing/edit-plan/g1/monthly">Upgrade</router-link> your Plan to gain access to the Hellopeter Facebook Integration and add the Hellopeter review tab to your business's Facebook page.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    /* eslint-disable indent,no-new,no-undef */
    import axios from 'axios'
    import misc from '../../mixins/misc.js'
    export default {
        metaInfo: {
            title: 'Business Portal | Hellopeter - Marketing'
        },
        mixins: [misc],
        mounted () {
            this.$gtm.trackEvent({
                event: 'pageLoad',
                virtualPageUrl: this.$router.currentRoute.path,
                virtualPageTitle: 'Marketing'
            })
        },
        data () {
            return {
                org_id: localStorage.getItem('org_id'),
                org_slug: localStorage.getItem('org_slug'),
                can_use_hp_metrics: false,
                can_use_hp_carousel: false,
                is_loading: true,
                subscriptionName: '',
                fbHeadImgUrl: `${process.env.APP_URL}/static/img/fb_icon_325x325.png`,
                hpImgUrl: `${process.env.APP_URL}/static/img/hp-social-int-logo.svg`,
                facebookImgUrl: `${process.env.APP_URL}/static/img/facebook-social-int.png`,
                originalLoginUrl: '',
                isAddTabButtonVisible: true,
                facebookPageId: '',
                pageAccessToken: ''
            }
        },
        created () {
            this.getBusinessDetails()
            this.getCurrentSubscriptionName()
            this.getFacebookLoginUrl()
            this.getBusinessPrivileges()
        },
        methods: {
            async getBusinessPrivileges () {
                try {
                    let businessPrivileges = await axios(`/business/get-business-privileges/${this.org_id}`)
                    this.can_use_hp_carousel = JSON.parse(businessPrivileges.data.can_use_hp_carousel)
                    this.can_use_hp_metrics = JSON.parse(businessPrivileges.data.can_use_hp_metrics)
                } catch (error) {
                    this.displayErrMsg(error, 'Failed fetching business privileges on Marketing Index View', defaultMsg = 'An unexpected error occurred. Please try again later.')
                }
            },
            /*
             * Add new tab on hellopeter facebook page
             *
             * returns {void}
             */
            addFacebookTab (event) {
              window.open(this.originalLoginUrl)
            },
              /*
             * Return current subscription name
             *
             * returns {string}
             */
            getCurrentSubscriptionName () {
              const businessSlug = localStorage.getItem('org_slug')
              axios.get(`/${businessSlug}/billing-details`)
                  .then(({data}) => {
                      this.subscriptionName = data.subscription.name
                  })
                  .catch((error) => {
                      this.displayErrMsg(error, 'Failed loading subscription details on Reports By Star Rating View', 'Oops, something went wrong. Please try reloading or contact our administrator')
                  })
            },
            /**
             * Function to get facebook login url
             *
             * @returns {void}
             *
             **/
            getFacebookLoginUrl () {
              const businessSlug = localStorage.getItem('org_slug')
              axios.get(`/social/fb/${businessSlug}/get-auth-url`)
                  .then(({data}) => {
                      this.originalLoginUrl = data.original_login_url
                  })
                  .catch((error) => {
                      this.displayErrMsg(error, 'Failed loading facebook login details', 'Oops, something went wrong. Please try reloading or contact our administrator')
                  })
            },
            /**
             * fetch business facebook page id
             * @returns {void}
             *
             **/
            getBusinessDetails () {
                axios.get(`/social/fb/${this.org_slug}/get-integration`)
                    .then(({data}) => {
                        this.facebookPageId = data.data.data.pageID
                        this.pageAccessToken = data.data.token
                        this.isAddTabButtonVisible = !this.pageAccessToken
                        this.is_loading = false
                    })
                    .catch(({error}) => {
                        this.is_loading = false
                        this.displayErrMsg(error, 'Failed loading business details', 'Oops, something went wrong. Please try reloading or contact our administrator')
                    })
            },
            /**
             * Remove tab from facebook page
             * @returns {void}
             * @param {void}
             **/
            removeFacebookTab () {
                axios.post(`/social/fb/${this.org_slug}/remove-facebook-page-tab`)
                    .then(() => {
                      location.reload()
                    })
                    .catch((error) => {
                      this.displayErrMsg(error, 'Failed removing facebook page tab', 'Oops, something went wrong. Please try reloading or contact our administrator')
                    })
            }
        },
        computed: {
          /*
           * Check current subscription is free or not
           *
           * returns {boolean}
           */
          isFreeSubscription () {
              return this.subscriptionName === 'Free'
          }
        }
    }
</script>
<style scoped>
  .about-feature {
    margin-top: -13px;
  }

  .report-row {
    background-color: #F5F5F5;
  }

  .section {
    padding: 1.5rem;
    margin-left: 0.75rem;
    margin-right: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .benchmarking {
    margin-top: 2.75rem;
  }

  .generic {
    margin-top: 1.75rem;
  }

  .level.is-mobile .level-item:last-child {
    margin-right: 0;
  }

  .level:not(:last-child) {
    margin-bottom: 0;
  }

  .upgrade-pkg-msg {
    font-size: 0.875em;
  }

  @media screen and (max-width: 767px) {
    .section {
      padding: 1rem 0.75rem;
    }
  }
  .fb-tab-landing-page {
    width: 40%;
    height: auto;
    border: solid 1px #dbdbdb;
    background-color: #ffffff;
    position: relative;
  }
  .fb-heading-section {
    height: auto;
    border-bottom: solid 1px #dbdbdb;
    display: flex;
    align-items: center;
    padding: 11px !important;
  }
  .fb-head-text {
    width: 125px;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
    text-align: left;
    color: #58595b;
    margin-left: 10px;
  }
  .social-img {
    padding: 42px 0px 0px 30px;
  }
  .btn-section {
    text-align: right;
    width: 100%;
    padding: 41px 0px 35px 30px;
  }
  .plus-icon {
    font-size: 33px;
    margin: -11px 13px 13px;
  }
  .note-text {
    padding-left: 30px;
    font-size: 12px;
    line-height: 1.42;
    letter-spacing: normal;
    text-align: left;
    color: #8a8c91;
    margin: -10px auto;
  }
  .head-content {
    font-size: 12px;
    color: #707070;
    line-height: 1.42;
    font-family: inherit;
    max-width: 805px;
  }
  .fb-tab-content {
    font-size: 12px;
    color: #707070;
    line-height: 1.42;
    font-family: inherit;
    padding: 16px 30px;
  }
  .fb-tab-content > a {
    text-decoration: underline;
  }

  .content-section {
    height: auto;
  }
  .information-desc {
    margin-top: 35px;
  }
  .main-head{
    left: 0px;
    right: 0px;
    padding: 13.5px 0px !important;
    margin-top: -1.8rem !important;
    color: #3b3c3d;
    font-size: 16px;
    font-weight: bold;
  }
  .columns main {
    padding-left: 0px !important;
  }
  .social-int-page {
    margin-left: 10px;
  }
  .head-border {
    margin-left: -1.9rem !important;
    margin-right: -1.5rem !important;
    margin-top: -1rem;
  }
  .lock-icon {
    right: 11px !important;
    position: absolute;
    margin-right: -0.5px;
  }
  .social-desc {
    margin-bottom: 26.5px;
  }
  .content-child-section {
    padding-right: 30px;
  }
  .information-desc img {
    width: 100%;
  }
  .fb-icon {
    margin-top: -7px;
  }
  .btn-section a {
    width: 180px;
  }
  .fr {
    text-align:right;
    right: 0px;
    float:right;
    padding-right:26px;
    width: 48%;
  }
  .is-add-tab-btn-disabled {
    pointer-events: none;
    cursor: default;
  }
  .tab-already-added-note {
    height: 68px;
    display: flex;
    border: solid 1px #17be86;
    margin-left: 30px;
    padding-left: 0;
  }
  .tab-already-added-note div span {
    color: #17be86;
  }
  .tab-already-added-note div:first-child {
    color: #fff;
    background: #17be86;
    width: 88px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 21px;
  }
  .tab-already-added-note div:last-child {
    padding: 14px 10px;
    background-color: rgba(23, 190, 134, 0.05);
  }
</style>



// WEBPACK FOOTER //
// src/pages/social-integration/FbIntegration.vue